import Loading from "@/components/Loading";
import AdminLayout from "@/layout/AdminLayout";
import React from "react";
import {PAGE_URL} from "../services/constant";
const AuthzPermissionGroupMapping = React.lazy(() =>
    import('../AuthzPermissionGroupMapping')
);
const authzPermissionGroupMappingRoutesRegistry = [
    {
        path: PAGE_URL.AUTHZ_PERMISSION_GROUP_MAPPING_PAGE,
        element: <AuthzPermissionGroupMapping />,
        loading: <Loading />,
        layout: AdminLayout,
    },
];

export default authzPermissionGroupMappingRoutesRegistry;
